export interface Category {
  id: string;
  nameKey: string;
  url: string;
}

export const categories: Category[] = [
  { id: "shoes", nameKey: "cat.shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: "hoodies", nameKey: "cat.hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { id: "tshirts", nameKey: "cat.tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { id: "jackets", nameKey: "cat.jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { id: "pants", nameKey: "cat.pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { id: "headwear", nameKey: "cat.headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { id: "sets", nameKey: "cat.sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { id: "underwear", nameKey: "cat.underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { id: "jersey", nameKey: "cat.jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { id: "accessories", nameKey: "cat.accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { id: "bags", nameKey: "cat.bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { id: "belts", nameKey: "cat.belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { id: "perfumes", nameKey: "cat.perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { id: "other", nameKey: "cat.other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];